exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-detail-prepayments .loans-detail-prepayments{padding-top:17px;padding-right:70px}loans-detail-prepayments .loans-detail-prepayments.mobile{padding-right:0}loans-detail-prepayments .loans-detail-prepayments-paragraph1{padding-bottom:11px}loans-detail-prepayments .loans-detail-prepayments-paragraph2{margin-bottom:0}loans-detail-prepayments .loans-detail-prepayments .bold{font-weight:700}loans-detail-prepayments .loans-detail-prepayments ul{list-style:none;padding-left:0}loans-detail-prepayments .loans-detail-prepayments ul li{font-size:15px}loans-detail-prepayments .loans-detail-prepayments ul li:before{content:\"\\2022\";margin-right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansDetail/loansDetailPrepayments/loansDetailPrepayments.scss
// module id = 1864
// module chunks = 0